module.exports = __webpack_public_path__ + "static/img/order-coupon-title1.7868f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order-coupon-title1.png
// module id = 341
// module chunks = 7